/* Copyright (c) 2017 Backpack Health LLC */

import { authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';

const MedicalTermsApi = {
  search: function searchMedicalTerms(query, languageCode, category, profileId) {
    return authorizedApiRequest('get', `terms?q=${encodeURIComponent(query)}&language_code=${languageCode}&category=${category}&profile_id=${profileId}`);
  },
  list: function listMedicalTerms(languageCode, listType, profileId) {
    return authorizedApiRequest('get', `terms/list?language_code=${languageCode}&list_type=${listType}&profile_id=${profileId}`);
  },
  constants: function constantMedicalTerms(languageCode, listType) {
    const lang = languageCode ? `language_code=${languageCode}` : '';
    return authorizedApiRequest('get', `terms/constants?list_type=${listType}&${lang}`);
  },
  composite: function compositeMedicalTerms(languageCode, listType) {
    const lang = languageCode ? `language_code=${languageCode}` : '';
    return authorizedApiRequest('get', `terms/composite?list_type=${listType}&${lang}`);
  },
};

const MedicalTermsService = {

  search(query, category, languageCode, profileId, callback) {
    return MedicalTermsApi.search(query, languageCode, category, profileId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body);
      });
  },

  list(listType, languageCode, profileId, callback) {
    return MedicalTermsApi.list(languageCode, listType, profileId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body);
      });
  },

  constants(listType, languageCode, callback) {
    return MedicalTermsApi.constants(languageCode, listType)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  composite(listType, languageCode, callback) {
    return MedicalTermsApi.composite(languageCode, listType)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  relatedUnits(cui, category, languageCode, callback) {
    return authorizedApiRequest('get', `terms/${cui}/${category}/${languageCode}/units`)
      .then((res) => {
        callback(null, res.body.data);
      });
  },

};

export interface MedliTermConstantItem {
  category: string;
  group: string;
  id: string;
  language_code: string;
  string: string;
}

export interface MedliTermCompositeItem {
  composite_term: string;
  delimiter: string;
  id: string;
  strings: object;
}

export interface MedliTermListItem {
  canonical_string: string;
  id: string;
  cui: string;
  language_code: string;
  string: string;
}

export interface MedliTermSearchItem {
  id: string;
  string: string;
  canonical_string: string;
  category: string;
  language_code: string;
  curated: boolean;
  short_definition: string;
  short_definition_source: string;
  long_definition_url: string;
  long_definition_source: string;
}

export default MedicalTermsService;
